import React, { Component, PropTypes } from 'react';
import Dropzone from 'react-dropzone';

import axios from 'axios';

import InputDropzoneDisplay from './dropzoneDisplay';

import css from './dropzone.scss';

export default class InputDropzone extends Component {
	static propTypes = {
		path: PropTypes.string.isRequired,
		inputs: PropTypes.array.isRequired,
		disableClick: PropTypes.bool,
		multiple: PropTypes.bool,
		accept: PropTypes.string,
		recommended: PropTypes.shape({
			width: PropTypes.number.isRequired,
			height: PropTypes.number.isRequired,
		}),
		disableDelete: PropTypes.bool.isRequired,
	};

	static defaultProps = {
		inputs: [],
		disableClick: false,
		multiple: false,
		accept: '',
		recommended: {
			width: 0,
			height: 0,
		},
		disableDelete: false,
	};

	constructor(props) {
		super();

		this.state = {
			openFileUpload: () => {},
		};
	}

	render() {
		let className = 'form-dropzone pixel-pattern pixel-pattern--10';

		if (this.props.inputs.length > 3) {
			className += ' form-dropzone--all-clear';
		}

		if (this.props.className) {
			className += ' ' + this.props.className;
		}

		if (!this.props.inputs.length) {
			return false;
		}

		return (
			<div className={className}>
				<div className='form-dropzone__container'>
					{this.props.inputs.map((input, i) => {
						return (
							<InputDropzoneDisplay {...this.props} ref='dropzone' key={input.name} name={input.name} preview={input.preview} disableDelete={this.props.disableDelete} bindOpen={this._bindOpen.bind(this)} recommended={this.props.recommended} />
						);
					})}
					<div className='cf'></div>
				</div>
			</div>
		);
	}

	_bindOpen(cb) {
		this.state.openFileUpload = cb;
	}

	open() {
		if (this.state.openFileUpload) {
			this.state.openFileUpload();
		}
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/form/dropzone/dropzone.js
 **/